import React from "react";

export const SubmissionsTable = ({ rows, columns }) => {
    if (!rows || rows.length === 0) {
        return <div className="card-soft p-8 text-center text-brand-muted">No submissions yet.</div>;
    }
    return (
        <div className="card-soft p-0 overflow-x-auto">
            <table className="w-full text-sm">
                <thead className="bg-brand-sand dark:bg-muted">
                    <tr>
                        {columns.map((c) => (
                            <th key={c.key} className="text-left p-4 font-semibold text-brand-navy dark:text-slate-100 text-xs uppercase tracking-wider">{c.label}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, idx) => (
                        <tr key={idx} className="border-t border-border">
                            {columns.map((c) => (
                                <td key={c.key} className="p-4 text-brand-text dark:text-slate-200 align-top">
                                    {c.key === "created_at"
                                        ? (row[c.key] ? new Date(row[c.key]).toLocaleString() : "")
                                        : Array.isArray(row[c.key])
                                            ? (row[c.key].join(", ") || "—")
                                            : (row[c.key] || row[c.key] === 0 ? String(row[c.key]) : "—")}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default SubmissionsTable;
